export const ExtractionInputFileds = [
  {
    label: 'Harvesting',
    fields: {
      rate: 'harvestingRate',
      uom: 'harvesting_UOM',
      note: 'harvestingNote',
      confirmedBy: 'harvestingConfirmedBy',
      email: 'harvestingEmail',
    },
  },
  {
    label: 'Forwarding',
    fields: {
      rate: 'forwardingRate',
      uom: 'forwarding_UOM',
      note: 'forwardingNote',
      confirmedBy: 'forwardingConfirmedBy',
      email: 'forwardingEmail',
    },
  },
];

export const initialExtractionRatesData = {
  contractUniqueID: null,
  harvestingRate: '',
  harvesting_UOM: null,
  harvestingNote: '',
  harvestingConfirmedBy: '',
  harvestingEmail: null,
  forwardingRate: '',
  forwarding_UOM: null,
  forwardingNote: '',
  forwardingConfirmedBy: '',
  forwardingEmail: null,
};
export const uomOptions = ['Per M3', 'Per Tonnes', 'Per Hour', 'Other - Notes'];
export const emailOptions = ['No', 'ECC email', 'MTG email', 'WTG email'];
